export default __webpack_public_path__ + "static/media/bg3.f0560b3b.jpg";